import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React, { useMemo, useState } from 'react';
import { Button } from '@attain-sre/attain-design-system';
import {
  CREATE_AUDIENCE,
  CREATE_AUDIENCE_WITH_IN_HOUSE,
  CREATE_WITH_IN_HOUSE,
  CREATE_WITH_TRANSUNION,
} from '../../content';
import { ENUM_SYSTEM_USED } from '../../constants';
import { Menu, MenuItem } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';

const CreateAudienceDropdown: any = (props: any) => {
  const {
    uiAudienceManagerLalModelingVisible = false,
    uiCustomAudienceManagerLalModelingVisible = false,
    uiUnifiedAudienceCreateWithTransunionVisible = false,
  } = useFlags();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { handleMenuItemClick, audienceType } = props;
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const showInHouseMenuItem = useMemo(() => {
    if (
      audienceType === ENUM_SYSTEM_USED.STANDARD_AUDIENCE &&
      uiAudienceManagerLalModelingVisible
    ) {
      return true;
    } else if (
      audienceType === ENUM_SYSTEM_USED.CUSTOM_AUDIENCE &&
      uiCustomAudienceManagerLalModelingVisible
    ) {
      return true;
    }
    return false;
  }, [audienceType]);

  if (!uiUnifiedAudienceCreateWithTransunionVisible) {
    return (
      <Button
        variant='contained'
        color='primary'
        onClick={() => {
          setAnchorEl(null);
          handleMenuItemClick('attain');
        }}
      >
        {CREATE_AUDIENCE}
      </Button>
    );
  }
  return (
    <div>
      <Button
        variant='contained'
        color='primary'
        endIcon={<ArrowDropDownIcon />}
        onClick={handleClick}
      >
        {CREATE_AUDIENCE}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {uiUnifiedAudienceCreateWithTransunionVisible && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              handleMenuItemClick('transunion');
            }}
          >
            {CREATE_WITH_TRANSUNION}
          </MenuItem>
        )}

        {showInHouseMenuItem && (
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              handleMenuItemClick('attain');
            }}
          >
            {CREATE_WITH_IN_HOUSE}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default CreateAudienceDropdown;
